import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pause",
  "use": "icon-pause-usage",
  "viewBox": "0 0 59 59",
  "content": "<symbol viewBox=\"0 0 59 59\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pause\"><g transform=\"translate(1 1)\"><circle cx=\"28.5\" cy=\"28.5\" r=\"28.5\" style=\"fill:none;stroke:#fff;stroke-width:2px\" /><path d=\"M20 19h3v22h-3z\" transform=\"matrix(1 0 0 1.04545 -1 -3.364)\" style=\"stroke:#fff;fill:#fff\" /><path d=\"M20 19h3v22h-3z\" transform=\"matrix(1 0 0 1.04545 15 -3.364)\" style=\"stroke:#fff;fill:#fff\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol